import { Inject, Injectable, Optional } from '@angular/core';
import { CartsService, NavigationConfig } from 'gung-standard';
import { HttpClient } from '@angular/common/http';
import { CartService, SelectedCustomerService, Customer, CartRow, Cart, GungFlowService } from 'gung-standard';
import { CarLinerMysetupService, MySetup } from './car-liner-mysetup.service';
import { first, forkJoin, Observable, switchMap } from 'rxjs';

const version = 'V2.0-20211015';
@Injectable({
  providedIn: 'root'
})
export class CarLinerCartService extends CartsService {
  constructor(
    protected http: HttpClient,
    protected cartService: CartService,
    protected selectedCustomerService: SelectedCustomerService,
    protected carLinerMysetupService: CarLinerMysetupService,
    protected gungFlowService: GungFlowService,
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig
  ) {
    super(http, cartService, selectedCustomerService, gungFlowService, environment);
  }

  saveQuotation(name: string, description: string): Observable<Cart> {
    let extra: any = {
      tag: 'QUOTE'
    };

    if (!!description) {
      extra = {
        ...extra,
        description
      };
    }

    const url = 'json/carts';
    return forkJoin({
      customer: this.selectedCustomerService.getSelectedCustomer().pipe(first()),
      rows: this.cartService.getCurrentCart().pipe(first()),
      mysetup: this.carLinerMysetupService.getMySetup().pipe(first())
    }).pipe(
      switchMap(({ customer, rows, mysetup }: { customer: Customer; rows: CartRow[]; mysetup: MySetup }) => {
        extra.mysetup = mysetup;
        return this.http.post<Cart>(url, { name, version, customerId: customer.id, extra, data: { rows } });
      })
    );
  }

  saveQuotationWithConditions(
    name: string,
    description: string,
    mySetupExtraOverride: Object,
    vat: Object,
    isVatSelected: boolean
  ): Observable<Cart> {
    let extra: any = {
      tag: 'QUOTE'
    };

    if (!!description) {
      extra = {
        ...extra,
        description
      };
    }

    const url = 'json/carts';
    return forkJoin({
      customer: this.selectedCustomerService.getSelectedCustomer().pipe(first()),
      rows: this.cartService.getCurrentCart().pipe(first()),
      mysetup: this.carLinerMysetupService.getMySetup().pipe(first())
    }).pipe(
      switchMap(({ customer, rows, mysetup }: { customer: Customer; rows: CartRow[]; mysetup: MySetup }) => {
        extra.mysetup = mysetup || {};
        extra.vat = vat || {};
        extra.isVatSelected = isVatSelected;
        extra.mysetup.extra = extra.mysetup.extra || {};
        extra.mysetup.extra.quotations = extra.mysetup.extra.quotations || {};
        if (extra?.mysetup?.extra?.quotations) {
          Object.keys(mySetupExtraOverride).forEach(k => {
            if (mySetupExtraOverride[k] != null) {
              extra.mysetup.extra.quotations[k] = mySetupExtraOverride[k];
            } else if (k === 'date' || k === 'expireDate') {
              extra.mysetup.extra.quotations[k] = extra.mysetup.extra.quotations[k] || {};
              extra.mysetup.extra.quotations[k] = { year: '', month: '', day: '' };
            }
          });
        }
        extra;
        extra.mysetup.currency = extra.mysetup.currency || customer?.extra?.kus?.valkod || '';
        extra.projectName = (this.environment as any).projectName
        return this.http.post<Cart>(url, { name, version, customerId: customer.id, extra, data: { rows } });
      })
    );
  }
}
